import styled from "styled-components";


export const DisabledMemberContainer = styled.div`
  margin: auto;
  width: 100%;
`;
export const DisabledMemberContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 450px;
  background: #FFFFFF;
  border-radius: 6px;
  padding: 2rem;
  margin: auto;
`;
export const DisabledMemberTitle = styled.div`
  font-size: var(--general-header-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-header-font-weight);
`;
export const DisabledMemberDescription = styled.div`
  font-size: var(--general-large-body-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-large-body-font-weight);
  width: 90%;
  text-align: center;
`;